import { lazy } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import useReduxStore from '../hooks/useReduxStore'
import { Toaster } from 'react-hot-toast'
import ReportDetails from '../pages/revenue_reports/index'
import ReportBookingDetails from '../pages/revenue_reports/Booking'
import ReportPaymentCommissionDetails from '../pages/revenue_reports/PaymentCommission'
import ReportCancelledConDetails from '../pages/revenue_reports/CancelledBooking'
import ReportCompletedConDetails from '../pages/revenue_reports/Completed'
import ReportPaymentRefundDetails from '../pages/revenue_reports/PaymentRefund'
import ReportPaymentReceivedDetails from '../pages/revenue_reports/PaymentReceived'
import Page404 from '../components/Page404'
import Booking from '../pages/client_management/Booking'
import Ticketbooking from '../pages/booking_management/ticketbooking'
import { ProtectedRoute } from './ProtectedRoute'
import Banner from '../pages/banner'
import PastEvent from '../pages/past_event'
// import Due_payments from '../pages/revenue_reports/Due_payments';
// import Details from '../pages/client_management/Details';
// import { Policy } from '@mui/icons-material';

// Layouts
const CredentialLayout = lazy(() => import('../layout/credentials'))
const Layout = lazy(() => import('../layout'))

// Credentials
const Login = lazy(() => import('../pages/credentials/login'))
const ResetPassword = lazy(() => import('../pages/credentials/reset'))
const ForgotPassword = lazy(() => import('../pages/credentials/forgot'))

const Dashboard = lazy(() => import('../pages/dashboard'))

// Vendor management
const VendorManagement = lazy(() => import('../pages/vendor_management'))
const VendorDetails = lazy(() => import('../pages/vendor_management/details'))
const VendorLocation = lazy(() => import('../pages/vendor_management/loactions'))
const VendorPlans = lazy(() => import('../pages/vendor_management/plans'))
const VendorPayments = lazy(() => import('../pages/vendor_management/payments'))
const VendorBookings = lazy(() => import('../pages/vendor_management/bookings'))
const VendorTeamMembers = lazy(() => import('../pages/vendor_management/team-member'))
const VendorAssignPlan = lazy(() => import('../pages/vendor_management/assign-plan'))
const ChangePassword = lazy(() => import('../pages/vendor_management/ChangePassword'))

// Team Management
const TeamManagement = lazy(() => import('../pages/team_management'))
const TeamDetails = lazy(() => import('../pages/team_management/Details'))
const Designation = lazy(() => import('../pages/team_management/Designation'))

// const Setup = lazy(() => import('../pages/setup'))
// const Setuppolicy = lazy(() => import('../pages/setup/Policy'));
// const SetupFaq = lazy(() => import('../pages/setup/Faq'))

const CouponsAndOffers = lazy(() => import('../pages/coupons_&_Offers'))

//booking management
const BookingManagement = lazy(() => import('../pages/booking_management/index'))
const MyBookings = lazy(() => import('../pages/booking_management/my_bookings'))
const CalendarIndex = lazy(() => import('../pages/booking_management/calendar_index'))
const Ticketbookings = lazy(() => import('../pages/booking_management/ticketbooking'))
const Calendar = lazy(() => import('../pages/booking_management/calendar'))
const BlockList = lazy(() => import('../pages/booking_management/blockList'))

// Ticket
const Ticket = lazy(() => import('../pages/ticket/index'))

// Registration Forms
const RegistrationForms = lazy(() => import('../pages/registration_forms'))
const RegistrationFormBuilder = lazy(() => import('../pages/registration_forms/FormBuilder'))

//Service Management
const ServiceManagement = lazy(() => import('../pages/service_management/index'))
const VendorServices = lazy(() => import('../pages/service_management/services'))
const VendorCategory = lazy(() => import('../pages/service_management/Category'))
const VendorCombos = lazy(() => import('../pages/service_management/combos'))

//Coupons & offers
const CouponsOffer = lazy(() => import('../pages/coupons_&_Offers'))

// setup
const Setup = lazy(() => import('../pages/setup'))
const Setuppolicy = lazy(() => import('../pages/setup/Policy'))
const SetupFaq = lazy(() => import('../pages/setup/Faq'))

// Template Library
const TemplateLibrary = lazy(() => import('../pages/template_library'))
const CreateTemplate = lazy(() => import('../pages/template_library/create-template'))

const Chat = lazy(() => import('../pages/chat'))

// roles permission
const Roles = lazy(() => import('../pages/roles'))
const RoleAndPermissions = lazy(() => import('../pages/roles/RoleAndPermissions'))
const TeamMember = lazy(() => import('../pages/roles/team_member'))
const RoleDetails = lazy(() => import('../pages/roles/team_member/Details'))
const AssignLocation = lazy(() => import('../pages/roles/assign-location'))
const AssignedLocation = lazy(() => import('../pages/roles/team_member/AssignedLocation'))

const ReviewManagement = lazy(() => import('../pages/review_management'))
const PlanManagement = lazy(() => import('../pages/plans_management'))
const PaymentManagement = lazy(() => import('../pages/payment_management'))
const Notifications = lazy(() => import('../pages/notifications'))

const PaymentSuccessfull = lazy(() => import('../pages/payment-status/payment-successfull'))

const ServiceReview = lazy(() => import('../pages/review-services/ServiceReview'))

//Client Management
const ClientManagement = lazy(() => import('../pages/client_management'))
const Details = lazy(() => import('../pages/client_management/Details'))
const Clientbooking = lazy(() => import('../pages/client_management/Booking'))
const Clientpayment = lazy(() => import('../pages/client_management/Payments'))
const TicketBooking = lazy(() => import('../pages/client_management/ticketbooking'))

//Ticket Easy
const TicketEasy = lazy(() => import('../pages/ticket_easy'))
const TicketDetails = lazy(() => import('../pages/ticket_easy/TicketDetails'))

//setting
const Setting = lazy(() => import('../pages/settings'))
const Policies = lazy(() => import('../pages/settings/Policies'))

const NotificationSettings = lazy(() => import('../pages/settings/NotificationSettings'))
const Queries = lazy(() => import('../pages/settings/Queries'))

// const Profile = lazy(() => import('../pages/profile/index'));
// const Profiledetails = lazy(() => import('../pages/profile/ProfileDetails'))

const AllRoutes = () => {
  const { selector: user } = useReduxStore('auth')
  const userPermissions = user?.userInfo?.permission || {}

  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />
      <Routes>
        <Route path="/payment-successfull" element={<PaymentSuccessfull />} />
        {!user?.token ? (
          <Route path="/" element={<CredentialLayout />}>
            <Route path="/" element={<Navigate replace to={'/login'} />} />
            {/* Credentials */}
            <Route path="login" element={<Login />} />
            <Route path="reset-password/vendor/:token" element={<ResetPassword />} />
            <Route path="reset-password/user/:token" element={<ResetPassword />} />
            <Route path="forgot-password" element={<ForgotPassword />} />
          </Route>
        ) : (
          <Route path="/" element={<Layout />}>
            <Route path="/" element={<Navigate replace to={'/dashboard'} />} />

            {/* Dashboard */}
            <Route path="dashboard" element={<Dashboard />} />

            {/* Team Management */}
            <Route
              path="team-management"
              element={
                <ProtectedRoute isPermission={userPermissions?.teamManagement}>
                  <TeamDetails />
                </ProtectedRoute>
              }
            >
              <Route path="/team-management" element={<Navigate replace to={'teams'} />} />
              <Route path="teams" element={<TeamManagement />} />
              <Route path="designation" element={<Designation />} />
            </Route>

            {/* Coupons and offers */}
            <Route
              path="coupons-&-offers"
              element={
                <ProtectedRoute isPermission={userPermissions?.couponsOffer}>
                  <CouponsAndOffers />
                </ProtectedRoute>
              }
            />
            {/* banner */}
            <Route path="banner" element={<Banner />} />
            {/* past events */}
            <Route path="past-events" element={<PastEvent />} />
            {/* vendor management */}
            <Route path="vendor-management" element={<VendorManagement />} />
            <Route path="vendor-management/plans" element={<VendorAssignPlan />} />
            <Route path="change-password" element={<ChangePassword />} />
            <Route path="profile" element={<VendorDetails />}>
              <Route path="/profile" element={<Navigate replace to={'location'} />} />
              <Route path="location" element={<VendorLocation />} />
              <Route path="team-member" element={<VendorTeamMembers />} />

              <Route path="plan" element={<VendorPlans />} />
              <Route path="payment" element={<VendorPayments />} />
              <Route path="services" element={<VendorServices />} />
              <Route path="booking" element={<VendorBookings />} />
            </Route>
            {/* Create Template */}
            <Route path="template-library" element={<TemplateLibrary />} />
            <Route path="template-library/create-template" element={<CreateTemplate />} />

            {/*Booking Management */}
            <Route
              path="booking-management/my-booking"
              element={
                <ProtectedRoute isPermission={userPermissions?.bookingManagement}>
                  <MyBookings />
                </ProtectedRoute>
              }
            >
              <Route path="/booking-management/my-booking" element={<Navigate replace to={'services-booking'} />} />
              <Route path="services-booking" element={<BookingManagement />} />
              <Route path="ticket-booking" element={<Ticketbookings />} />
            </Route>

            <Route path="booking-management/calendar" element={<CalendarIndex />}>
              <Route path="/booking-management/calendar" element={<Navigate to={'view'} />} />
              <Route path="view" element={<Calendar />} />
              <Route path="block-dates" element={<BlockList />} />
            </Route>
            <Route
              path="booking-management/calendar"
              element={
                <ProtectedRoute isPermission={userPermissions?.bookingManagement}>
                  <CalendarIndex />
                </ProtectedRoute>
              }
            />

            {/*Ticket */}
            <Route
              path="ticket"
              element={
                <ProtectedRoute isPermission={userPermissions?.ticket}>
                  <Ticket />
                </ProtectedRoute>
              }
            />

            {/* Registration Forms */}
            <Route path="registration-forms" element={<RegistrationForms />} />
            <Route path="registration-forms/create" element={<RegistrationFormBuilder />} />
            <Route path="registration-forms/edit/:id" element={<RegistrationFormBuilder />} />

            {/*Service Management */}
            <Route
              path="service-management"
              element={
                <ProtectedRoute isPermission={userPermissions?.serviceManagement}>
                  <ServiceManagement />
                </ProtectedRoute>
              }
            >
              <Route path="/service-management" element={<Navigate replace to={'services'} />} />
              <Route path="category" element={<VendorCategory />} />
              <Route path="services" element={<VendorServices />} />
              <Route path="packages" element={<VendorCombos />} />
            </Route>

            {/*Coupons & Offers */}
            {/* <Route path='coupons-&-offers' element={
                            <ProtectedRoute isPermission={userPermissions?.couponsOffer}>
                                <CouponsOffer />
                            </ProtectedRoute>
                        } /> */}

            {/*payments*/}
            <Route
              path="payment-management"
              element={
                <ProtectedRoute isPermission={userPermissions?.payments}>
                  <PaymentManagement />
                </ProtectedRoute>
              }
            />

            {/*reports-analytic*/}
            <Route
              path="reports-analytic"
              element={
                <ProtectedRoute isPermission={userPermissions?.reportsAndAnalytics}>
                  <ReportDetails />
                </ProtectedRoute>
              }
            >
              <Route path="/reports-analytic" element={<Navigate replace to={'booking'} />} />
              <Route path="booking" element={<ReportBookingDetails />} />
              <Route path="payment-commission" element={<ReportPaymentCommissionDetails />} />
              <Route path="cancelled" element={<ReportCancelledConDetails />} />
              <Route path="completed" element={<ReportCompletedConDetails />} />
              <Route path="payment-refund" element={<ReportPaymentRefundDetails />} />
              <Route path="payment-received" element={<ReportPaymentReceivedDetails />} />
            </Route>

            {/* services review */}
            <Route
              path="/service-review"
              element={
                <ProtectedRoute isPermission={userPermissions?.reviewServices}>
                  <ServiceReview />
                </ProtectedRoute>
              }
            />

            {/*chat*/}
            <Route
              path="chat"
              element={
                <ProtectedRoute isPermission={userPermissions?.chat}>
                  <Chat />
                </ProtectedRoute>
              }
            />

            {/* setup */}
            <Route
              path="setup"
              element={
                <ProtectedRoute isPermission={userPermissions?.setup}>
                  <Setup />
                </ProtectedRoute>
              }
            >
              <Route path="/setup" element={<Navigate replace to={'faq'} />} />
              {/* <Route path='policies' element={<Setuppolicy />} /> */}
              <Route path="faq" element={<SetupFaq />} />
            </Route>

            {/* roles & permission */}
            <Route path="roles" element={<Navigate replace to={'/roles/team-member'} />} />
            <Route path="roles/team-member" element={<TeamMember />} />
            <Route path="roles/team-member/:id" element={<RoleDetails />}>
              <Route path="/roles/team-member/:id" element={<Navigate replace to={'location'} />} />
              <Route path="location" element={<AssignedLocation />} />
            </Route>
            <Route path="roles/permission" element={<Roles />} />
            <Route path="roles/permission/:id" element={<RoleAndPermissions />} />

            <Route path="roles/permission/assignlocation" element={<AssignLocation />} />
            <Route path="roles/permission/addrole" element={<AssignLocation />} />
            <Route path="roles/team-member/:id/assignlocation/" element={<AssignLocation />} />
            <Route path="roles/team-member/:name/:id" element={<RoleDetails />} />
            <Route path="roles/permission" element={<Roles />} />
            <Route path="roles/permission/assignlocation" element={<AssignLocation />} />
            <Route path="roles/permission/addrole" element={<AssignLocation />} />
            <Route path="roles/team-member/:name/:id/assignlocation/" element={<AssignLocation />} />

            <Route path="review-management" element={<ReviewManagement />} />
            <Route path="plan-management" element={<PlanManagement />} />
            <Route path="notifications" element={<Notifications />} />
            <Route
              path="ticket-easy"
              element={
                <ProtectedRoute isPermission={userPermissions?.ticketEasy}>
                  <TicketEasy />
                </ProtectedRoute>
              }
            />
            <Route
              path="ticket-easy/:id"
              element={
                <ProtectedRoute isPermission={userPermissions?.ticketEasy}>
                  <TicketDetails />
                </ProtectedRoute>
              }
            />

            {/*Client Management */}
            <Route
              path="client-management"
              element={
                <ProtectedRoute isPermission={userPermissions?.clientManagement}>
                  <ClientManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="client-management/profiles/:id"
              element={
                <ProtectedRoute isPermission={userPermissions?.clientManagement}>
                  <Details />
                </ProtectedRoute>
              }
            >
              {/* <Route path="/client-management/profiles/:id" element={<Navigate replace to={'booking'} />} /> */}
              <Route path="/client-management/profiles/:id/booking" element={<Clientbooking />} />
              {/* <Route path="booking" element={<Clientbooking />} /> */}
              <Route path="payment" element={<Clientpayment />} />
              <Route path="ticketbooking" element={<TicketBooking />} />
            </Route>

            {/*Settings */}
            <Route path="settings" element={<Navigate replace to={'/settings/dashboard'} />} />
            <Route path="settings/dashboard" element={<Setting />} />
            <Route path="settings/policy" element={<Policies />} />

            <Route path="settings/notification" element={<NotificationSettings />} />
            <Route path="settings/queries" element={<Queries />} />
          </Route>
        )}
        <Route path="*" element={<Page404 />} />
      </Routes>
    </>
  )
}

export default AllRoutes
